/* eslint-disable */
import http from "../../api/http"; /** file configured to make requests to the server with fetch */
import auth from "../../auth";
var _ = require("lodash");
const actions = {
    FetchLogin({commit},payload) {
        return http.post("login", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                if (auth.saveAut2Storage(response)) {
                  commit('SetIdMainGroup',response.DATA.groups[0]['ID']);
                }
                // auth.logIn(response.DATA.username,response.DATA.email,response.DATA.user_id,response.DATA.token);
                // auth.set_language(response.DATA.lang);
                // auth.set_groups(response.DATA.groups);
                // commit('SetIdMainGroup',response.DATA.groups[0]['ID']);
                // auth.set_id_group_active(response.DATA.groups[0]['id_group'])
                // auth.set_id_subgroup_active(response.DATA.groups[0]['id_subgroup']);
                // auth.set_id_role_active(response.DATA.groups[0]['id_role'])
            } 
            return response;
        });
    },
    FetchLoginLtiEnd({commit},payload) {
        return http.post("lti/login/end", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                if (auth.saveAut2Storage(response)) {
                  commit('SetIdMainGroup',response.DATA.groups[0]['ID']);
                }
                // auth.logIn(response.DATA.username,response.DATA.email,response.DATA.user_id,response.DATA.token);
                // auth.set_language(response.DATA.lang);
                // auth.set_groups(response.DATA.groups);
                // commit('SetIdMainGroup',response.DATA.groups[0]['ID']);
                // auth.set_id_group_active(response.DATA.groups[0]['id_group'])
                // auth.set_id_subgroup_active(response.DATA.groups[0]['id_subgroup']);
                // auth.set_id_role_active(response.DATA.groups[0]['id_role'])
            } 
            return response;
        });
    },
    FetchResetPass({},payload) {
        return http.post("resetPassword", payload).then(response => {
            return response;
        });
    },
};
export default actions;